import styled, { css } from 'styled-components';

import { PaletteColor } from '@utils/types';
import {
  BoxIcon,
  CheckedRedIcon,
  CheckedWhiteIcon,
  BoxIconWhite,
} from '@assets/icons';

export const Outline = styled(BoxIcon)`
  position: absolute;
  width: 100%;
  height: 100%;
`;
export const SegmentOutline = styled(BoxIconWhite)`
  position: absolute;
  width: 100%;
  height: 100%;
`;
export const CheckMark = styled(CheckedRedIcon)`
  position: relative;
  z-index: 1;
  left: 4px;
`;
export const SegmentCheck = styled(CheckedWhiteIcon)`
  position: relative;
  z-index: 1;
  left: 4px;
`;
export const Container = styled.div<{
  clickable?: boolean;
  outlineColor?: PaletteColor;
  checkMarkColor?: PaletteColor;
}>`
  width: 20px;
  height: 20px;
  position: relative;
  ${({ clickable }) => clickable && 'cursor: pointer'}
  ${Outline} {
    ${(p) =>
      p.outlineColor &&
      css`
        path {
          fill: ${p.theme.palette[p.outlineColor]};
        }
      `}
  }
  ${CheckMark} {
    ${(p) =>
      p.checkMarkColor &&
      css`
        path {
          fill: ${p.theme.palette[p.checkMarkColor]};
        }
      `}
  }
`;

export const Unchecked = styled.div<{
  checked?: boolean;
  outlineColor?: PaletteColor;
  segment?: boolean;
}>`
  width: 20px;
  height: 20px;
  min-width: 16px;
  border-radius: 2px;
  border: solid 2px
    ${({ theme, outlineColor, segment }) =>
      segment ? theme.palette.white : theme.palette[outlineColor ?? 'grey']};
  position: relative;
  ${({ onClick }) => onClick && 'cursor: pointer'}
`;
